import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    plan: [],
    planLoading: false,
  },
  mutations: {
    setPlan(state, payload) {
      state.plan = payload;
    },
    setPlanLoading(state, payload) {
      state.planLoading = payload;
    },
  },
  actions: {
    async loadPlan({ commit }, id) {
      commit("setPlanLoading", true);
      let list = await api.get("sustainability/fullPlan", {
        params: {
          id: id,
        },
      });
      commit("setPlan", list.data);
      commit("setPlanLoading", false);
    },
  },
  getters: {
    plan(state) {
      return state.plan;
    },
    planLoading(state) {
      return state.planLoading;
    },
  },
};
